import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import Row from "../components/Row/Row";
import { ConfigContext } from "../App";
import Loading from "../components/Loading/Loading.js";

/**
 * Home page component.
 * Expects `content` to be loaded asynchronously (may be null initially).
 *
 * @param {Object} props
 * @param {Object|null|undefined} props.content - Home page content data (e.g. from Sanity).
 * @returns {JSX.Element}
 */
function Home({ content }) {
  const configuration = useContext(ConfigContext);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const setRowsContent = () => {
      setIsLoading(true);
      setRows(content?.rows ?? []);
      setIsLoading(false);
    };
    setRowsContent();
  }, [content]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>{configuration.title}</title>
        <meta name="description" content={content?.metaDescription} />
      </Helmet>
      <div className="home">
        {rows.map((row, index) => {
          return <Row columns={row.columns} bgColor={row.background?.color} key={`row-${index}`} />;
        })}
      </div>
    </>
  );
}

export default Home;
